// lib/list/listOutputPersonas.ts
import { z } from 'zod';
import type { ListOutputPersonaAssociation } from '#types/types';

const associations = z.array(z.object({
  id: z.string().uuid(), identityRevision: z.number().int().positive().safe(),
  handle: z.string().regex(/^[a-z0-9-]{1,48}$/).optional(), enabled: z.boolean().optional(),
})).max(2);

/** Null distinguishes corrupt provenance from an output with no saved persona. */
export function readListOutputPersonas(params: unknown): ListOutputPersonaAssociation[] | null {
  const record = params && typeof params === 'object' && !Array.isArray(params) ? params as Record<string, unknown> : {};
  const parsed = associations.safeParse(record.listPersonaContext ?? record.listPersonas ?? []);
  if (!parsed.success) return null;
  const disabled = record.listPersonaDisabled && typeof record.listPersonaDisabled === 'object' && !Array.isArray(record.listPersonaDisabled)
    ? record.listPersonaDisabled as Record<string, unknown> : {};
  return parsed.data.map(persona => ({ ...persona, enabled: typeof disabled[persona.id] === 'boolean' ? !disabled[persona.id] : persona.enabled !== false }));
}
